import React, { useEffect, useMemo, useState } from "react";
import { Input } from "@/components/ui/input";

export function TripPersonPicker({ value, onChange, people, placeholder, testId, disabled }) {
  const [query, setQuery] = useState(value || "");
  const [open, setOpen] = useState(false);
  useEffect(() => setQuery(value || ""), [value]);
  const matches = useMemo(() => {
    const search = query.trim().toLocaleLowerCase("it-IT");
    return people.filter((person) => person.name.toLocaleLowerCase("it-IT").includes(search));
  }, [people, query]);
  const selectPerson = (person) => { onChange(person.name); setQuery(person.name); setOpen(false); };
  const close = () => window.setTimeout(() => { setOpen(false); setQuery(value || ""); }, 120);

  return <div className="relative">
    <Input
      data-testid={testId}
      value={query}
      disabled={disabled}
      placeholder={placeholder}
      autoComplete="off"
      onFocus={() => setOpen(true)}
      onBlur={close}
      onChange={(event) => { setQuery(event.target.value); setOpen(true); }}
      onKeyDown={(event) => {
        if (event.key === "Escape") { event.currentTarget.blur(); }
        if (event.key === "Enter" && matches.length === 1) { event.preventDefault(); selectPerson(matches[0]); }
      }}
    />
    {open && !disabled && <div data-testid={`${testId}-options`} role="listbox" className="absolute z-20 mt-1 max-h-52 w-full overflow-y-auto rounded-md border border-slate-200 bg-white p-1 shadow-lg">
      {matches.map((person) => <button key={person.id} data-testid={`${testId}-option-${person.id}`} type="button" role="option" className="flex w-full items-center px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-100" onMouseDown={(event) => event.preventDefault()} onClick={() => selectPerson(person)}>{person.name}</button>)}
      {matches.length === 0 && <p data-testid={`${testId}-no-results`} className="px-3 py-2 text-sm text-slate-500">Nessun risultato</p>}
    </div>}
  </div>;
}